var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.tagClass,style:([_vm.customStyle, _vm.tagStyle])},[(_vm.icon)?_c('v-icon',{class:_vm.icon,style:(_vm.iconStyle)}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }